var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3954 14.347L8.89538 18.097C8.84983 18.1653 8.79127 18.224 8.72303 18.2697C8.6548 18.3154 8.57823 18.3472 8.49771 18.3633C8.33508 18.3958 8.16619 18.3624 8.02819 18.2704C7.8902 18.1784 7.7944 18.0354 7.76188 17.8727C7.72935 17.7101 7.76276 17.5412 7.85476 17.4032L10.3548 13.6532C10.4468 13.5152 10.5898 13.4194 10.7524 13.3869C10.9151 13.3544 11.0839 13.3878 11.2219 13.4798C11.3599 13.5718 11.4557 13.7148 11.4883 13.8775C11.5208 14.0401 11.4874 14.209 11.3954 14.347ZM17.1149 5.83995C17.0262 4.32288 16.3592 2.89757 15.2512 1.8575C14.1432 0.817429 12.6786 0.241783 11.159 0.249092C9.63933 0.256401 8.18034 0.846108 7.08241 1.89679C5.98448 2.94746 5.33121 4.37913 5.2571 5.89698C5.24798 6.05896 5.17761 6.2114 5.06024 6.32341C4.94287 6.43541 4.7873 6.49858 4.62507 6.50011H4.57819C4.4132 6.48536 4.26048 6.40682 4.15251 6.2812C4.04454 6.15558 3.98985 5.99278 4.00007 5.82745C4.02179 5.3929 4.08271 4.96119 4.1821 4.53761C4.19492 4.48442 4.19356 4.4288 4.17814 4.3763C4.16273 4.32381 4.1338 4.27628 4.09425 4.23848C4.0547 4.20067 4.00593 4.17391 3.95279 4.16087C3.89966 4.14783 3.84403 4.14897 3.79148 4.16417C2.94545 4.41412 2.20356 4.93222 1.67755 5.64042C1.15155 6.34862 0.86991 7.20857 0.87507 8.09073C0.890695 10.3337 2.75944 12.1251 5.00319 12.1251H7.8321L5.97976 14.9032C5.88776 15.0412 5.85435 15.2101 5.88688 15.3727C5.9194 15.5354 6.0152 15.6784 6.15319 15.7704C6.29119 15.8624 6.46008 15.8958 6.62271 15.8633C6.78534 15.8308 6.92838 15.735 7.02038 15.597L9.33444 12.1251H11.1876C11.9963 12.1242 12.7964 11.9583 13.5388 11.6375C14.2811 11.3166 14.9503 10.8477 15.5051 10.2593C16.06 9.67097 16.489 8.97555 16.7658 8.21565C17.0426 7.45575 17.1614 6.64736 17.1149 5.83995Z",
    fill: "url(#paint0_linear_393_82872)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_82872",
    x1: 0.874999,
    y1: 18.3754,
    x2: 21.1653,
    y2: 8.91572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4169E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadness);
export default __webpack_public_path__ + "static/media/Sadness.9796ddfafa800146aa5a845a3f9c9033.svg";
export { ForwardRef as ReactComponent };